import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=05c5a701&scoped=true&"
import script from "./Telephone.vue?vue&type=script&lang=js&"
export * from "./Telephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5a701",
  null
  
)

export default component.exports